import { ToggleButton } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ImageIcon from '@mui/icons-material/Image'
import { useTiptapEditor } from 'ra-input-rich-text'
import { useCallback } from 'react'
import { ImageButtonsProps } from './type'

export const ImageButtons: React.FC<ImageButtonsProps> = (props) => {
  const editor = useTiptapEditor()
  const addImage = useCallback(() => {
    const url = window.prompt('Image url')

    if (url) {
      editor.chain().focus().setImage({ src: url }).run()
    }
  }, [editor])

  return editor ? (
    <ToggleButton
      aria-label='Image'
      title='Image'
      {...props}
      disabled={!editor?.isEditable}
      value='image'
      onClick={addImage}
    >
      <ImageIcon fontSize='inherit' />
      <ArrowDropDownIcon sx={{ width: 'auto', height: 'auto' }} />
    </ToggleButton>
  ) : null
}
